

import { PUB_SUB_EVENTS, subscribe, publish } from '@lib/pubsub';
import { SectionId, HTMLUpdateUtility, Animations } from '@lib/section-utils';
// import { ProductForm } from '@lib/product-form';


if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('[ref="quantityInput"]');
        if (!this._variantCache) this._variantCache = new Map();

        this.blockId = this.dataset.blockId ? this.dataset.blockId : this.sectionId
  
        
        this.section = this.closest('.shopify-section');
        this.savedIndex = 0;
        
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('[data-quantity-form]');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      
      handleOptionValueChange({ data: { event, target, selectedOptionValues, selectedVariant } }) {
        if (!event?.target || !this.contains(event.target)) return;

        this.productForms.forEach((productForm) => productForm?.handleErrorMessage?.());

        const picker = event.target.closest('variant-picker');
        const localVariant = selectedVariant || picker?.selectedVariant || null;

        // Najpierw ustawiamy formularz lokalnie. Przycisk nie może pozostawać
        // zablokowany tylko dlatego, że odświeżenie sekcji jeszcze trwa lub nie odpowie.
        if (localVariant?.id) {
          this.applyVariantImmediately(localVariant);
        } else {
          this.updateVariantInputs(null);
          this.setSubmitState(true, window.variantStrings.unavailable);
        }

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;

        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage,
            localVariant?.id
          ),
          targetId: target.id,
          callback: (html) => {
            if (shouldSwapProduct) {
              this.handleSwapProduct(productUrl, shouldFetchFullPage)(html);
            } else {
              this.handleUpdateProductInfo(productUrl, localVariant)(html);
            }
          }
        });
      }


      resetProductFormState() {
        this.productForms.forEach((productForm) => {
          productForm?.handleErrorMessage?.();
        });
      }

      setSubmitState(disable, text) {
        this.productForms.forEach((productForm) => {
          if (typeof productForm?.toggleSubmitButton === 'function') {
            productForm.toggleSubmitButton(disable, text);
          }

          const button = productForm?.querySelector('button[type="submit"][name="add"]');
          if (!button) return;
          button.disabled = Boolean(disable);
          if (disable) button.setAttribute('aria-disabled', 'true');
          else button.removeAttribute('aria-disabled');
          button.classList.toggle('is-disabled', Boolean(disable));

          const label = button.querySelector('[data-button-text]');
          if (label) {
            label.textContent = text || (disable ? window.variantStrings.unavailable : window.variantStrings.addToCart);
          }
        });
      }

      applyVariantImmediately(variant) {
        if (!variant?.id) {
          this.updateVariantInputs(null);
          this.setSubmitState(true, window.variantStrings.unavailable);
          return;
        }

        this.updateVariantInputs(variant.id);
        const canAdd = variant.can_add !== undefined ? variant.can_add !== false : variant.available !== false;
        this.setSubmitState(!canAdd, canAdd ? undefined : window.variantStrings.soldOut);
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
          Animations.initAll();
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`Nie udało się odświeżyć wariantu (HTTP ${response.status}).`);
            return response.text();
          })
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
            this.pendingRequestUrl = null;
            // Formularz pozostaje poprawny dzięki lokalnej aktualizacji wariantu.
          });
      }

 
      getSelectedVariant(productInfoNode) {
        if (!productInfoNode) return null;

        // W tym motywie variant-picker zapisuje JSON pod kluczem opartym
        // raz o block.id, a w innych kontekstach o section.id. Po odpowiedzi
        // AJAX nie wolno uznać wariantu za niedostępny tylko dlatego, że
        // pierwszy z tych kluczy nie występuje w zwróconym HTML.
        const selectedVariant =
          productInfoNode.querySelector(
            `variant-picker [data-selected-variant="${this.blockId}-${this.dataset.productId}"]`
          )?.textContent ||
          productInfoNode.querySelector(
            `variant-picker [data-selected-variant="${this.sectionId}-${this.dataset.productId}"]`
          )?.textContent ||
          productInfoNode.querySelector('variant-picker script[data-selected-variant]')?.textContent;

        if (!selectedVariant || !selectedVariant.trim()) return null;
        try {
          const parsed = JSON.parse(selectedVariant);
          return parsed && parsed.id ? parsed : null;
        } catch (error) {
          console.error('Nie udało się odczytać wybranego wariantu.', error);
          return null;
        }
      }

      buildRequestUrlWithParams(url, optionValues = [], shouldFetchFullPage = false, variantId = null) {
        const params = [];
        if (!shouldFetchFullPage) params.push(`section_id=${encodeURIComponent(this.sectionId)}`);
        if (variantId) params.push(`variant=${encodeURIComponent(variantId)}`);
        if (Array.isArray(optionValues) && optionValues.length) {
          params.push(`option_values=${optionValues.map(encodeURIComponent).join(',')}`);
        }
        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const newVariantInfo = html.querySelector(`[data-bundle-product-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        const oldVariantInfo = document.querySelector(`[data-bundle-product-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);

        const newVariantPopupInfo = html.querySelector(`[data-bundle-popup-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        const oldVariantPopupInfo = document.querySelector(`[data-bundle-popup-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
    

        if (newVariantInfo && oldVariantInfo) { 
          oldVariantInfo.innerHTML = newVariantInfo.innerHTML;
        }
        if (newVariantPopupInfo && oldVariantPopupInfo) { 
          oldVariantPopupInfo.innerHTML = newVariantPopupInfo.innerHTML;
        }
        const ButtonnewVariantInfo = html.querySelector(`[data-bundle-product-variant-button="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        const ButtonoldVariantInfo = document.querySelector(`[data-bundle-product-variant-button="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        if (ButtonnewVariantInfo && ButtonoldVariantInfo) { 
          ButtonoldVariantInfo.innerHTML = ButtonnewVariantInfo.innerHTML;
        } 
        const variantSelects = html.querySelector(`#variant-selects-${this.dataset.productId}-${this.blockId}`);
    
        if (variantSelects && this.variantSelectors) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }

        const targetElement = document.getElementById(
          `bundle-info-${this.sectionId}-${this.blockId}-${this.dataset.productId}`
        );
    
        setTimeout(() => {
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest'
            });
          }
        },100);
          
      }
      get hideVariants() {
        return this._hideVariants = this._hideVariants || this.querySelectorAll('.product-media--variant').length > 0;
      }

      handleUpdateProductInfo(productUrl, localVariant = null) {
        return (html) => {
          const variant = this.getSelectedVariant(html) || localVariant || this.querySelector('variant-picker')?.selectedVariant || null;
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          // Update the data-selected-variant-id on the product-bundle button
          const productBundleButton = document.querySelector(`[data-block-id="${this.blockId}"][data-product-url="${productUrl}"][is="product-bundle"]`);
          if (productBundleButton && variant?.id) {
            productBundleButton.dataset.selectedVariantId = variant.id; 
          }

          if (!variant) {
            this.setUnavailable();
            return;
          }
          
          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}-${this.productId}`);
            const destination = this.querySelector(`#${id}-${this.sectionId}-${this.productId}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('price-sticky');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('ProductInventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Sku');

          if (this.querySelector(`#Quantity-Rules-${this.sectionId}-${this.productId}`)) {
            updateSourceFromDestination('Quantity-Rules');
            updateSourceFromDestination('Quantity-Form');
          }
          // updateSourceFromDestination('Quantity-Form');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.sectionId}-${this.productId}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.sectionId}-${this.productId}`)?.classList.remove('hidden');

          // this.productForm?.toggleSubmitButton(
          //   html.getElementById(`ProductSubmitButton-${this.sectionId}-${this.productId}`)?.hasAttribute('disabled') ?? true,
          //   window.variantStrings.soldOut
          // );
          const mainSubmitButton = html.getElementById(
            `ProductSubmitButton-${this.sectionId}-${this.productId}`
          );
          const stickySubmitButton = html.getElementById(
            `StickyProductSubmitButton-${this.sectionId}-${this.productId}`
          );

          this.productForms.forEach((productForm) => {
            const formId = productForm.querySelector('form')?.id || '';
            const sourceButton = formId.toLowerCase().startsWith('sticky-')
              ? stickySubmitButton
              : mainSubmitButton;
            const fallbackCanAdd = variant.can_add !== undefined ? variant.can_add !== false : variant.available !== false;
            const shouldDisable = sourceButton ? sourceButton.hasAttribute('disabled') : !fallbackCanAdd;

            if (typeof productForm?.toggleSubmitButton === 'function') {
              productForm.toggleSubmitButton(
                shouldDisable,
                shouldDisable ? window.variantStrings.soldOut : undefined
              );
            }
            const button = productForm.querySelector('button[type="submit"][name="add"]');
            if (button) {
              button.disabled = shouldDisable;
              if (shouldDisable) button.setAttribute('aria-disabled', 'true');
              else button.removeAttribute('aria-disabled');
            }
          });


          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
          Animations.initAll();
        };
      }

      updateVariantInputs(variantId) {
        this.productForms.forEach((productForm) => {
          const input = productForm.querySelector('form input[name="id"].product-variant-id, form input[name="id"]');
          if (!input) return;

          input.value = variantId ?? '';
          input.disabled = !variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.querySelectorAll('form[id^="product-form-installment-"] input[name="id"]').forEach((input) => {
          input.value = variantId ?? '';
          input.disabled = !variantId;
        });

        const formSelector = `#Bundle-ProductForm-${this.sectionId}-${this.blockId}`;
        const formEl = document.querySelector(formSelector);
        const bundleInput = formEl?.querySelector(
          `input.product-variant-id[data-product-handle="${this.dataset.productHandle}"]`
        );
        if (bundleInput) {
          bundleInput.value = variantId ?? '';
          bundleInput.disabled = !variantId;
        }
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForms.forEach((productForm) => {
          productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);
        });
        // this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['ProductInventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules','price']
          .map((id) => `#${id}-${this.sectionId}-${this.productId}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));

       const priceWrapper = document.querySelector(`[data-bundle-popup-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`)?.querySelector('.product-price');
              // 🔹 remove existing badge if present
      if(!priceWrapper) return;
              priceWrapper.querySelector('.product-cardbadge')?.remove();

              // 🔹 add badge only when needed
              priceWrapper.insertAdjacentHTML(
                'beforeend',
                `<span class="product-cardbadge on-sale text-xxsmall">
                  ${window.variantStrings.unavailable}
                </span>`
      );
        
       
      }

      updateMedia(parsedHTML, variantFeaturedMediaId) {

        if (!variantFeaturedMediaId) return;

        const id = 'MediaGallery';
        const source = parsedHTML.getElementById(`${id}-${this.sectionId}-${this.productId}`);
        const destination = document.querySelector(`#${id}-${this.sectionId}-${this.productId}`);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.removeAttribute('hidden');


          let primarySlider = destination.querySelector('[product-media-gallery]');

          if (primarySlider) {
            this.mainSwiper = window.SwiperSlide(primarySlider, JSON.parse(primarySlider.getAttribute('data-swiper')));
            const isMobile = window.innerWidth < 768;

            if (isMobile) {
              // Destroy Swiper if exists
              if (this.mainSwiper) {
                this.mainSwiper.destroy(true, true);
                this.mainSwiper = null;
              }
            } else {
              // Desktop: init Swiper if not exists
              if (!this.mainSwiper) this.initSwiper();
            }
            
          }

        }

      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        } 
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        // const currentVariantId = this.productForm?.variantIdInput?.value;
        const currentVariantId = [...this.productForms][0]?.variantIdInput?.value;
        if (!currentVariantId) return;
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => { });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}-${this.productId}`);
        if (!quantityFormUpdated || !this.quantityForm) return;
        const selectors = ['[data-product-quantity]', '.quantity-rules', '.quantity-label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.[data-product-quantity]') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
      get bundlePopupSwiper() {
        const bundlePopup = document.querySelector('bundle-popup');
        return bundlePopup && bundlePopup.swiper ? bundlePopup.swiper : null;
      }

      // get productForm() {
      //   return this.querySelector(`product-form`);
      // }
      get productForms() {
        return this.querySelectorAll('product-form');
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector(`#variant-selects-${this.dataset.productId}-${this.blockId}`);
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }

    }
  );
}

if (!customElements.get('sticky-addtocart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.mainFormId;
      this.close = this.querySelector('[data-close]');
      this.targetElement = document.getElementById(this.formId);
      this.footer = document.querySelector('footer');

      if (!this.targetElement) return;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleClose = this.handleClose.bind(this);

      window.addEventListener('scroll', this.handleScroll);

      if (this.close) {
        this.close.addEventListener('click', this.handleClose);
      }

      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);

      if (this.close) {
        this.close.removeEventListener('click', this.handleClose);
      }
    }

    handleScroll() {
      if (this.classList.contains('hidden')) return;

      const rect = this.targetElement.getBoundingClientRect();

      let footerVisible = false;

      if (this.footer) {
        const footerRect = this.footer.getBoundingClientRect();
        footerVisible = footerRect.top < window.innerHeight;
      }

      // Hide when footer visible
      if (footerVisible) {
        this.classList.remove('is-visible');
        return;
      }

      // Show when form scrolls above viewport
      if (rect.bottom <= 0) {
        this.classList.add('is-visible');
      }

      // Hide when form visible again
      else if (rect.top >= 0) {
        this.classList.remove('is-visible');
      }
    }

    handleClose() {
      this.classList.add('hidden');
      this.classList.remove('is-visible');
    }
  }

  customElements.define('sticky-addtocart', StickyAddToCart);
}